import { useState } from 'react'
import cadex, { Base_Uuid } from '@cadexchanger/web-toolkit'

import { BomItemAPI } from 'controllers/Project/BomItemAPI'
import { RequestStatus } from 'services/APIs/BaseAPI'
import { CadExProviderProps, ModelNode } from '../types'
import { CadExContext } from './CadExContext'
import { buildUseSceneElementsContext } from './hooks'

export const CadExProvider = ({ children, ...props }: CadExProviderProps) => {
  const [model] = useState<cadex.ModelData_Model>(new cadex.ModelData_Model())
  const [scene] = useState<cadex.ModelPrs_Scene>(new cadex.ModelPrs_Scene())
  const [treeModel, setTreeModel] = useState<Map<Base_Uuid, ModelNode>>(
    new Map()
  )
  const [viewPort, setViewPort] = useState<cadex.ModelPrs_ViewPort>()

  const getContext = () => {
    return {
      model,
      treeModel,
      scene,
      viewPort,
      setTreeModel,
      setViewPort,
    }
  }

  const { partyId, projectId, is2DModel, reference, itemId } = props
  // eslint-disable-next-line
  const handleLoading = (requestStatus: Partial<RequestStatus>) => {}

  const bomItemAPI = new BomItemAPI(partyId, projectId, handleLoading)

  const dataLoader = (itemId: string, theObjId: string) =>
    is2DModel
      ? bomItemAPI.Get2DCdxfbFile(itemId, theObjId)
      : bomItemAPI.Get3DCdxfbFile(itemId, theObjId)

  const useSceneElements = buildUseSceneElementsContext(
    { dataLoader, reference, modelName: itemId },
    getContext
  )

  return (
    <CadExContext.Provider value={{ useSceneElements, getContext }}>
      {children}
    </CadExContext.Provider>
  )
}
